import React, { useState } from 'react';
import { KiteButton, KiteIcon } from '@kite/react-kite';

interface CarouselControlsProps {
    slideNos: number;
    currentSlide: number;
    next: number;
    setNext: (value: number) => void;
    setCurrentSlide: (value: number) => void;
    setDirection: (direction: string) => void;
    setApplyIndexOrder: (value: boolean) => void;
}

export const CarouselControls = ({
    currentSlide,
    setCurrentSlide,
    next,
    setNext,
    slideNos,
    setDirection,
    setApplyIndexOrder,
}: CarouselControlsProps) => {
    const [previous, setPrevious] = useState(slideNos);

    const handleOnSlideSelect = (ind: number, arrLength: number) => {
        setCurrentSlide(ind + 1); //assign current slide to the
        setPrevious(ind - 1);
        setNext(ind + 1);
        if (ind + 1 >= arrLength) {
            setNext(0);
        }
        if (ind <= 1) {
            setPrevious(arrLength);
        }
    };

    const handleNextSlide = () => {
        setCurrentSlide(currentSlide + 1);
        setNext(next + 1);
        if (currentSlide >= slideNos) {
            setCurrentSlide(1);
        }
        if (currentSlide + 1 >= slideNos) {
            setNext(0);
        }

        setDirection(`right`);
        setApplyIndexOrder(true);
    };

    const handlePrevSlide = () => {
        setCurrentSlide(currentSlide - 1);
        setNext(next - 1);
        if (currentSlide <= 0) {
            setNext(slideNos);
        }
        if (currentSlide - 1 <= 0) {
            setCurrentSlide(slideNos);
            setNext(0);
        }
        setDirection(`left`);
        setApplyIndexOrder(true);
    };

    return (
        <div className="carousel-controls">
            <div className="carousel-wrapper">
                <div className="carousel-pagination">
                    <div className="button-control-group">
                        {currentSlide > 1 && (
                            <KiteButton
                                value="Previous"
                                onClick={handlePrevSlide}
                                className="previous"
                                variant="borderless"
                            >
                                <KiteIcon
                                    icon="ki-arrow-left"
                                    size="1.65rem"
                                    ariaLabel="Previous slide"
                                />
                            </KiteButton>
                        )}
                        <KiteButton
                            value="Next"
                            onClick={handleNextSlide}
                            className="next"
                            variant="borderless"
                        >
                            {currentSlide === 1 && (
                                <>
                                    <span>Begin</span>
                                </>
                            )}
                            {currentSlide === slideNos && (
                                <>
                                    <span>Restart</span>
                                </>
                            )}

                            {currentSlide === slideNos ? (
                                <KiteIcon
                                    ariaLabel="Restart carousel"
                                    color="var(--kite-color-primary)"
                                    icon="ki-jump-forward-arrow"
                                    size="2rem"
                                />
                            ) : (
                                <KiteIcon
                                    icon="ki-arrow-right"
                                    size="1.65rem"
                                    ariaLabel="Next slide"
                                />
                            )}
                        </KiteButton>
                    </div>
                    <div className="pagination-group">
                        {[...Array(slideNos)].map(
                            (
                                page,
                                i //'pages' is passed as a number - the length of the slides, then created to an Array so as to loop...
                            ) => (
                                <button
                                    key={`${page}_${i}`}
                                    className={`pagination-button ${
                                        i + 1 === currentSlide
                                            ? `current-slide`
                                            : `` //check if the index + 1 is equal to the current slide in the carousel
                                    } `}
                                    type="button"
                                    onClick={() => {
                                        handleOnSlideSelect(i, slideNos);
                                    }}
                                >
                                    <span>Slide {i}</span>
                                </button>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
